<template>
  <section>
    <z-popup
      v-model="showCondition"
      position="bottom"
      class="b2c-pop-wrapper"
      :get-container="getContainer"
    >
      <div v-zpm="{ areaexposure: 123 }" class="pop-title">
        <span>{{ popTitle || '' }}</span>
        <div class="mask_img" @click="togglePopup">
          <img
            src="https://pic6.zhuanstatic.com/zhuanzh/1b8afb9f-426f-46dc-92b2-4cc6dcfdcce3.png"
          />
        </div>
      </div>
      <div class="params-desc">
        <div v-for="(item, index) in qcWikiDesc" :key="index" class="item-desc">
          {{ item }}
        </div>
      </div>
      <div class="pop_wrapper">
        <!-- <div
          v-if="
            reportData.qcWiki && reportData.qcWiki.qcWikiDesc && reportData.qcWiki.qcWikiDesc.length
          "
          class="report_list"
        >
          <div
            v-for="(item, index) in reportData.qcWiki.qcWikiDesc"
            :key="index"
            :class="['item_report active']"
          >
            <div class="report_valueDesc">
              {{ item }}
            </div>
          </div>
        </div> -->
        <!-- 质检报告 -->
        <div v-if="standardDefines && standardDefines.length" class="report_list">
          <div
            v-for="(item, index) in standardDefines"
            :key="index"
            :class="['item_report', item.mark == 1 ? 'active' : '']"
          >
            <div class="report_value">{{ item.qcItemName }}</div>
            <div class="report_valueDesc">
              <div v-for="(zItem, zIndex) in item.defineDesc" :key="zIndex">{{ zItem }}</div>
            </div>
          </div>
        </div>

        <div v-if="impactDesc && impactDesc.length" class="impactDesc-content">
          <div class="impactDesc-title">使用体验有什么差异？</div>
          <div class="impactDesc-list">
            <div v-for="(item, index) in impactDesc" :key="index" class="item-impactDesc">
              {{ item }}
            </div>
          </div>
        </div>
        <div v-if="nineStandardDefines && nineStandardDefines.length" class="standardDefines">
          <div class="standardDefines-list">
            <div
              v-for="(item, index) in nineStandardDefines"
              :key="index"
              :class="['item-content', item.mark === 1 ? 'active' : '']"
            >
              <div class="item-label">{{ item.qcItemName }}</div>
              <div class="item-value">
                <span v-for="(list, i) in item.defineDesc" :key="list.valueText">{{ list }} </span>
              </div>
            </div>
          </div>
        </div>
        <div class="report_photo">
          <img v-if="qcWikiImg" class="img_report" :src="$setPicSize(qcWikiImg, 1000, 1000)" />
        </div>
      </div>
    </z-popup>
  </section>
</template>

<script>
  import { setPicSize } from '@zz-common/zz-utils'
  import { Popup } from '@zz-common/zz-ui'
  export default {
    name: 'base-pop-item',
    props: {
      report: {
        type: Object,
        default: () => {},
      },
      pageId: {
        type: String,
        default: 'T2974',
      },
      getContainer: {
        type: [String, Object],
        default: null,
      },
    },
    components: {
      [Popup.name]: Popup,
    },
    data() {
      return {
        popTitle: '',
        qcWikiImg: '',
        reportData: {},
        showCondition: false,
        qcWiki: null, // 九宫格数据
        standardDefines: [], // 网络制式数据
      }
    },
    computed: {
      $setPicSize() {
        return setPicSize
      },
      /**
       * $ 百科信息
       */
      qcWikiDesc() {
        return this.qcWiki && this.qcWiki.qcWikiDesc ? this.qcWiki.qcWikiDesc : []
      },
      /**
       * $ 网络制式数据  优先取它，没有的话取 解释说明impactDesc数据
       */
      nineStandardDefines() {
        return this.qcWiki && this.qcWiki.standardDefines ? this.qcWiki.standardDefines : []
      },
      /**
       * $ 解释说明
       */
      impactDesc() {
        return this.qcWiki && this.qcWiki.impactDesc ? this.qcWiki.impactDesc : []
      },
      /**
       * $ 验机百科图片
       */
      smallEncyclopediaPic() {
        return this.qcWiki && this.qcWiki.qcWikiImg ? this.qcWiki.qcWikiImg : ''
      },
    },
    methods: {
      togglePopup(data) {
        this.reportData = data
        const { qcWiki } = data
        if (qcWiki) this.qcWiki = data.qcWiki
        // $ 质检标题
        this.popTitle = `${data.key}: ${data.value}`
        this.qcWikiImg = (data.qcWiki && data.qcWiki.qcWikiImg) || '' // $ 质检小图标
        this.showCondition = !this.showCondition
        if (this.$legoSend) {
          if (this.showCondition) {
            // $ 弹窗展示埋点
            this.$legoSend({
              pagetype: 'PopupShow',
              actiontype: this.pageId,
              backup: {
                popupname: '九宫格弹窗',
                name: data.key,
                value: data.value,
              },
            })
          } else {
            // $ 关闭弹窗埋点
            this.$legoSend({
              pagetype: 'PopupClick',
              actiontype: this.pageId,
              backup: {
                popupname: '关闭九宫格弹窗',
                sortid: 0,
                sortName: '关闭',
              },
            })
          }
        }
      },
    },
  }
</script>

<style lang="scss">
  .b2c-pop-wrapper {
    padding-top: 24px;
    .pop-title {
      position: relative;
      height: 148px;
      line-height: 70px;
      font-size: 28px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #111;
      text-align: center;
      background: url('https://pic2.zhuanstatic.com/zhuanzh/3a6c2303-1b00-45c4-b29b-ae538578f160.png')
        no-repeat 0 0;
      background-size: cover;
      margin-top: -24px;
      // margin-bottom: 20px;
      padding-top: 25px;
      box-sizing: border-box;
      span {
        position: absolute;
        left: 32px;
        bottom: 0;
        // transform: translateX(-50%);
      }
      .mask_img {
        position: absolute;
        top: 21px;
        right: 32px;
        width: 48px;
        height: 48px;
        img {
          width: 24px;
          height: 24px;
        }
      }
    }

    .params-desc {
      padding: 12px 32px 0;
      .item-desc {
        margin-top: 10px;
        margin-bottom: 24px;
        color: #111;
        font-weight: 400;
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        line-height: 40px;
      }
    }

    .pop_wrapper {
      padding: 0 32px calc(constant(safe-area-inset-bottom));
      padding: 0 32px calc(env(safe-area-inset-bottom));
      max-height: 70vh;
      overflow-y: scroll;
      box-sizing: border-box;
      // height: 500px;
      .report_list {
        // margin: 0 0 48px;
        .item_report {
          display: flex;
          .report_valueDesc {
            width: 100%;
            margin-bottom: 4px;
            padding: 32px;
            background: #f8f9fd;
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999;
            line-height: 40px;
          }
        }
        .active {
          .report_value,
          .report_valueDesc {
            color: #111;
          }
          .report_value {
            font-family: PingFangSC-Semibold, PingFang SC;
          }
        }
        .item_report:first-child {
          .report_value {
            border-top-left-radius: 12px;
          }
          .report_valueDesc {
            border-top-right-radius: 12px;
          }
        }
        .item_report:last-child {
          .report_value {
            border-bottom-left-radius: 12px;
          }
          .report_valueDesc {
            border-bottom-right-radius: 12px;
          }
        }
      }
      .impactDesc-content {
        padding: 28px 32px;
        background: #f8f9fd;
        border-radius: 12px;
        margin-bottom: 20px;
        .impactDesc-title {
          margin-bottom: 20px;
          color: #111;
          font-weight: 500;
          font-size: 26px;
          font-family: PingFangSC-Medium, PingFang SC;
          line-height: 32px;
        }
        .impactDesc-list {
          .item-impactDesc {
            margin-bottom: 32px;
            color: #111111;
            font-weight: 400;
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            line-height: 40px;
          }
        }
      }

      .standardDefines-list {
        overflow: hidden;
        border-radius: 12px;
        .item-content {
          display: flex;
          color: #999;
          font-weight: 400;
          font-size: 26px;
          font-family: PingFangSC-Regular, PingFang SC;
          line-height: 32px;
          .item-label {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 168px;
            margin: 0 0 4px;
            padding: 27px 10px 27px 20px;
            background: #f8f9fd;
            border-right: 4px solid #fff;
          }
          .item-value {
            width: calc(100% - 172px);
            margin-bottom: 4px;
            padding: 27px 10px 27px 20px;
            background: #f8f9fd;
          }
        }
        .active {
          color: #111;

          .item-label {
            font-weight: 600;
            font-family: PingFangSC-Semibold, PingFang SC;
          }
        }
      }
      .report_photo {
        margin-top: 48px;
        border-radius: 12px;
        overflow: hidden;
        background: #f8f8f8;
        .img_report {
          width: 100%;
          height: auto;
          border-radius: 12px;
          max-height: 100%;
        }
      }
    }
  }
</style>
